import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActiveStatus } from '@app/interface/common';
import { Constant } from '@core';
import { StudyModel } from '@app/interface';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '@shared/spinner/spinner.service';
import { StudiesService, UserService, EmailTemplatesService } from '@app/services';
import { ProviderDataValidators as Validators } from '@app/modules/data-valiidator';
import * as firebase from 'firebase';
import Quill from 'quill';
import getPlaceholderModule from 'quill-placeholder-module';
// @ts-ignore
import getAutocompleteModule from 'quill-placeholder-autocomplete-module';
import { CustomMenuComponent } from './custom-menu/custom-menu.component';

const placeholders = [
  { id: 'User-Name', label: 'User-Name' },
  { id: 'Email Address', label: 'Email Address' },
  { id: 'StudyID', label: 'StudyID' },
  { id: 'Study-Name', label: 'Study-Name' },
  { id: 'Organization', label: 'Organization' },
  { id: 'Survey-Name', label: 'Survey-Name' },
];

Quill.register(
  'modules/placeholder',
  // @ts-ignore
  getPlaceholderModule(Quill, {
    className: 'ql-placeholder-content', // default
  })
);

Quill.register('modules/autocomplete', getAutocompleteModule(Quill));
@Component({
  selector: 'app-add-edit-email-template',
  templateUrl: './addEditEmailTemplate.html',
  styleUrls: ['./addEditTemplate.component.scss'],
})
export class AddEditEmailTemplateComponent implements OnInit {
  emailTemplateForm: FormGroup;
  submitted = false;
  success: boolean;
  date = new Date().toISOString();
  isLoading = false;
  templateStatus: ActiveStatus[] = Constant.ActiveStatus;
  @Input() title_tag: string;
  @Input() formType: string;
  @Input() form_data: any;
  studyDetail: StudyModel;
  menuComponent = CustomMenuComponent;
  triggerCharacter = '^';
  quillConfig = {
    //toolbar: '.toolbar',
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['code-block'],
        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        //[{ 'direction': 'rtl' }],                         // text direction

        //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        //[{ 'font': [] }],
        //[{ 'align': [] }],

        ['clean'], // remove formatting button

        ['link'],
        //['link', 'image', 'video']
      ],
    },
    placeholder: {
      delimiters: ['{', '}'], // default
      placeholders,
    },
    autocomplete: {
      getPlaceholders: () => placeholders, // factory
      //container: document.querySelector("#completions"), // can also be return of `document.querySelector` or kept `undefined`
      triggerKey: '{', // default
      endKey: '}', // optional
      debounceTime: 0, // 0: disabled (default)
    },
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          handler: () => {
            console.log('enter');
            return true;
          },
        },
      },
    },
  };

  constructor(
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinnerService: SpinnerService,
    public userService: UserService,
    private emailTemplatesService: EmailTemplatesService,
    private studiesService: StudiesService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getStudyDetail();
  }

  private getStudyDetail(studyName?: string): void {
    this.studiesService.getStudyDetailById().subscribe((study: StudyModel) => {
      this.studyDetail = study;
    });
  }

  get formControl() {
    return this.emailTemplateForm.controls;
  }

  private createForm(): void {
    this.emailTemplateForm = this.formBuilder.group({
      uuid: [],
      subject: ['', [Validators.required()]],
      templateName: ['', [Validators.required()]],
      body: ['', [Validators.required()]],
      createdAt: [firebase.default.firestore.Timestamp.now()],
    });
    if (this.formType === 'Edit') {
      this.emailTemplateForm.patchValue(this.form_data);
    }
  }

  private submitAddEditEmailTemplate(emailTemplateDate: any) {
    this.emailTemplatesService.addEmailTemplate(emailTemplateDate, this.studyDetail).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  public updateEmailTemplate(emailData: any) {
    this.emailTemplatesService.updateEmailTemplate(emailData).subscribe(() => {
      this.isLoading = false;
      this.submitted = false;
      this.activeModal.close(true);
      this.spinnerService.hide();
    });
  }

  public save(): void {
    this.submitted = true;
    if (this.emailTemplateForm.valid) {
      const emailTemplateDate = this.emailTemplateForm.value;
      this.isLoading = true;
      this.spinnerService.show();
      console.log(emailTemplateDate);
      if (this.formType === 'Edit') {
        this.updateEmailTemplate(emailTemplateDate);
      } else {
        this.submitAddEditEmailTemplate(emailTemplateDate);
      }
    } else {
      return;
    }
  }
}
